/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tense_Whole_Swan_PromiseInputs */

const fr_tense_whole_swan_promise = /** @type {(inputs: Tense_Whole_Swan_PromiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondes`)
};

/**

* @param {Tense_Whole_Swan_PromiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tense_whole_swan_promise = /** @type {((inputs?: Tense_Whole_Swan_PromiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tense_Whole_Swan_PromiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tense_whole_swan_promise(inputs)
});